import React, { PropsWithChildren } from "react";
//#region types
import { MasterRowSummaryViewProps } from "models/propTypes/editableTableProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const MasterRowSummaryView: React.FC<PropsWithChildren<MasterRowSummaryViewProps>> = (props) => {
  return (
    <Grid container alignItems={"center"} spacing={3} direction="row" className={cssExports.masterRowSummaryContainer}>
      <Grid item>
        <Grid container spacing={1} direction="row">
          <Grid item className={cssExports.inheritIcon}>
            <Icon icon={IconDefinitionConstants.WArrowDownRight}></Icon>
          </Grid>
          <Grid item className={cssExports.inheritLabel}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.InheritsFromMasterRow, undefined, {
              entityName: props.entityName,
            })}
            :
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs className={cssExports.inheritContent}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default MasterRowSummaryView;
